export const generateMetaData = (postData: any, pageTypeData: any) => {
  const data = {
    title: "",
    description: "",
    thumbnail: "",
    canonicalURL: "",
  };

  const {
    isAttributeType,
    isCollectionType,
    isRecipeType,
    slug,
    completeSlug,
  } = pageTypeData;

  let canonicalURL = "";

  if (isRecipeType) {
    const {
      title = "",
      share_meta_image_link = "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/logo-c305d1c2dc6e4a9cb2d7767c4d9c213b.png",
      description,
      share_details: shareDetails,
    } = postData || {};
    const { share_url: shareUrl } = shareDetails?.[0] || {};

    if (shareUrl) {
      let [protocol, origin] = shareUrl.split("//");
      origin = origin.replace("www.", "");
      canonicalURL = `https://www.${origin}/`;
    }

    data.title = title;
    data.description = description;
    data.thumbnail = share_meta_image_link;
    data.canonicalURL = canonicalURL;
  }

  if (isAttributeType) {
    if (typeof window !== "undefined") {
      let [protocol, origin] = window.location.origin.split("//");
      origin = origin.replace("www.", "");
      let pathNameArray: any = window.location.pathname.split("/");
      pathNameArray = pathNameArray.slice(2).join("/");
      canonicalURL = `https://www.${origin}/recipes/${pathNameArray}/`;
    }
    const {
      web_title = `Recipes for ${slug} attribute`,
      web_image_url = "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/logo-c305d1c2dc6e4a9cb2d7767c4d9c213b.png",
      web_description = `Recipes for ${slug} attribute`,
    } = postData || {};

    data.title = web_title;
    data.description = web_description;
    data.thumbnail = web_image_url;
    data.canonicalURL = canonicalURL;
  }
  if (isCollectionType) {
    if (typeof window !== "undefined") {
      let [protocol, origin] = window.location.origin.split("//");
      origin = origin.replace("www.", "");
      let pathNameArray: any = window.location.pathname.split("/");
      pathNameArray = pathNameArray.slice(2).join("/");
      canonicalURL = `https://www.${origin}/recipes/${pathNameArray}/`;
    }
    const {
      web_title = `Recipes for ${slug} collection`,
      web_image_url = "https://d1mxd7n691o8sz.cloudfront.net/static/mindhouse/imagerepo/2026-04/logo-c305d1c2dc6e4a9cb2d7767c4d9c213b.png",
      web_description = `Recipes for ${slug} collection`,
    } = postData || {};

    data.title = web_title;
    data.description = web_description;
    data.thumbnail = web_image_url;
    data.canonicalURL = canonicalURL;
  }

  if (data?.canonicalURL.endsWith("/"))
    data.canonicalURL = data.canonicalURL.substring(
      0,
      data.canonicalURL.length - 1
    );

  return data;
};

export const checkRecipeSlugType = (recipeSlug: string | undefined) => {
  const data = {
    isCollectionType: false,
    isAttributeType: false,
    isRecipeType: false,
    slug: "",
    completeSlug: "",
  };
  if (!recipeSlug) {
    return data;
  }
  let recipeSlugsWords = recipeSlug.split("-");

  if (recipeSlugsWords[0] === "collection") {
    data.isCollectionType = true;
  } else if (recipeSlugsWords[0] === "attribute") {
    data.isAttributeType = true;
  } else {
    data.isRecipeType = true;
  }
  data.completeSlug = recipeSlugsWords
    .slice(0, recipeSlugsWords.length + 1)
    .join("-");

  if (data.isRecipeType) {
    data.slug = data.completeSlug;
  } else {
    data.slug = recipeSlugsWords
      .slice(1, recipeSlugsWords.length + 1)
      .join("-");
  }
  return data;
};
